import { PaletteOptions } from '@mui/material';
import { HEADER_TEXT_COLOR } from './color';

export const palette: PaletteOptions = {
  customColors: {
    black: HEADER_TEXT_COLOR,
  },
  common: {
    black: '#181818',
  },
  background: {
    default: '#ffffff',
  },
  primary: {
    main: '#181818',
    light: '#2e2d2d',
  },
  secondary: {
    main: '#2e2d2d',
  },
  action: {
    disabled: '#d7d7d7',
  },
  grey: {
    '100': '#d7d7d7',
  },
  text: {
    primary: '#181818',
    secondary: '#808080',
  },
};
